// src/pages/qc/WaterAnalysisModal.jsx
import { useState } from "react";
import { todayDubai } from "../../utils/dateUtils";

const WATER_TYPES = [
  { value: "FEED",   label: "Feed Water"   },
  { value: "RO",     label: "RO Water"     },
  { value: "REJECT", label: "Reject Water" },
];

const EMPTY = {
  date:        todayDubai(),
  waterType:   "",
  tds:         "",
  ph:          "",
  tempC:       "",
  appearance:  "",
  deliveredBy: "",
  remarks:     "",
};

function num(v) { return v === "" ? null : parseFloat(v); }

function Row({ label, children }) {
  return (
    <div className="form-row">
      <span className="form-label">{label}</span>
      <div style={{ display:"flex", gap:6, alignItems:"center", flex:1 }}>{children}</div>
    </div>
  );
}

export function WaterAnalysisModal({ onSave, onCancel }) {
  const [form, setForm]   = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [error,  setError]  = useState(null);

  function set(k, v) { setForm(f => ({ ...f, [k]: v })); }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.waterType) { setError("Water type is required."); return; }
    setSaving(true); setError(null);
    try {
      await onSave({
        date:        form.date,
        waterType:   form.waterType,
        tds:         num(form.tds),
        ph:          num(form.ph),
        tempC:       num(form.tempC),
        appearance:  form.appearance.trim()  || null,
        deliveredBy: form.deliveredBy.trim() || null,
        remarks:     form.remarks.trim()     || null,
      });
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  }

  return (
    <div className="modal">
      <div className="modal-header">
        <h3 className="modal-title">Add Water Analysis</h3>
        <button className="btn" onClick={onCancel}>✕</button>
      </div>

      <form onSubmit={handleSubmit}>
        <Row label="Date">
          <input type="date" className="form-input" value={form.date}
            onChange={e => set("date", e.target.value)} required style={{ width:160 }} />
        </Row>

        <Row label="Water Type *">
          <select className="form-select" value={form.waterType}
            onChange={e => set("waterType", e.target.value)} style={{ flex:1 }} required>
            <option value="">— select type —</option>
            {WATER_TYPES.map(t => (
              <option key={t.value} value={t.value}>{t.label}</option>
            ))}
          </select>
        </Row>

        <div className="form-sep" />

        <Row label="TDS (ppm)">
          <input type="number" className="form-input" step="any" value={form.tds}
            onChange={e => set("tds", e.target.value)} placeholder="e.g. 420" style={{ width:130 }} />
        </Row>

        <Row label="pH">
          <input type="number" className="form-input" step="any" value={form.ph}
            onChange={e => set("ph", e.target.value)} placeholder="e.g. 7.2" style={{ width:100 }} />
        </Row>

        <Row label="Temperature (°C)">
          <input type="number" className="form-input" step="any" value={form.tempC}
            onChange={e => set("tempC", e.target.value)} placeholder="e.g. 25.0" style={{ width:100 }} />
        </Row>

        <Row label="Appearance">
          <input className="form-input" value={form.appearance}
            onChange={e => set("appearance", e.target.value)}
            placeholder="e.g. Clear & Bright" style={{ flex:1 }} />
        </Row>

        <div className="form-sep" />

        <Row label="Delivered By">
          <input className="form-input" value={form.deliveredBy}
            onChange={e => set("deliveredBy", e.target.value)}
            placeholder="Name of person who delivered the sample" style={{ flex:1 }} />
        </Row>

        <Row label="Remarks">
          <textarea className="form-input" rows={2} value={form.remarks}
            onChange={e => set("remarks", e.target.value)}
            placeholder="Optional notes…" style={{ flex:1, resize:"vertical" }} />
        </Row>

        <div style={{ fontSize:11, color:"#9ca3af", marginTop:8 }}>
          Entry time will be recorded automatically.
        </div>

        {error && <div className="alert-warn" style={{ marginTop:8 }}>{error}</div>}

        <div style={{ display:"flex", gap:8, justifyContent:"flex-end", marginTop:16 }}>
          <button type="button" className="btn" onClick={onCancel} disabled={saving}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? "Saving…" : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
}
